import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendCustomerPersonaConnection,
  BackendQueryCustomerPersonasArgs,
} from 'src/types/backend';

import { CUSTOMER_PERSONA_FRAGMENT } from './schema';

const QUERY = gql`
  query CustomerPersonas($brandVoiceId: ID!, $projectId: ID) {
    customerPersonas(brandVoiceId: $brandVoiceId, projectId: $projectId) {
      edges {
        node {
          ...CustomerPersona
        }
      }
    }
  }
  ${CUSTOMER_PERSONA_FRAGMENT}
`;

type Variables = BackendQueryCustomerPersonasArgs;
type Result = BackendCustomerPersonaConnection;

export const queryCustomerPersonas = async (variables: Variables) => {
  const result = await executeGqlQuery({ query: QUERY, variables });
  return getSingleProp<Result>(result.data);
};
